import NewConsumerPopUpComponent from "./newConsumerPopup.component";
import {useDispatch, useSelector} from "react-redux";
import React, {useEffect, useState} from "react";
import {useHistory} from "react-router-dom";
import {getNewConsumerRegisteredList} from "../../../redux/action/dashboard.action";
import {ROOT as CONSUMER_ROOT} from "../../../../consumer";
import {ROOT as SERIAL_NUMBER_ROOT} from "../../../../serial-number";

export default function NewConsumerPopUpContainer({
  isOpen,
  handleClose,
  startDate,
  endDate,
}) {
  const dispatch = useDispatch();
  const history = useHistory();
  const lang = useSelector((state) => state.constant.languages);
  const newConsumerRegisteredList = useSelector(state => state.dashboard.newConsumerRegisteredList);

  const [page, setPage] = useState(0);

  useEffect(() => {
    dispatch(getNewConsumerRegisteredList({startDate, endDate, page}))
  }, [dispatch, startDate, endDate, page]);

  const handleLoadingMore = () => {
    if (newConsumerRegisteredList.records.length === newConsumerRegisteredList.totalRecords) return;

    setPage(page + 1);
  }

  const handleConsumerNameClick = (id) => {
    history.push(CONSUMER_ROOT + '/' + id);
  }

  const handleSerialNumberClick = (id) => {
    history.push(SERIAL_NUMBER_ROOT + '/details/' + id);
  }

  return <NewConsumerPopUpComponent
    isOpen={isOpen}
    handleClose={handleClose}
    lang={lang}
    rows={newConsumerRegisteredList.records}
    haveNext={newConsumerRegisteredList.hasNextPage}
    totalRecords={newConsumerRegisteredList.totalRecords}
    handleLoadingMore={handleLoadingMore}
    handleConsumerNameClick={handleConsumerNameClick}
    handleSerialNumberClick={handleSerialNumberClick}
  />
}
